import { Box, Hidden, Stack, Typography, useTheme } from "@mui/material"
import { ReactElement } from "react"

import AppButton from "../../components/buttons/appButton"
import LctHoneyCombMask from "../../components/images/lctHoneyCombMask"
import DisplayIf from "../../components/wrappers/displayIf"
import { useGetUserData } from "../../hooks/useGetUserData"

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: Unreachable code error
// eslint-disable-next-line no-undef
const CONFIG = GLOBAL_CONFIG

interface UnapprovedUserHomepageProps {
    awaitingSetUp: boolean
}

/** Displayed when user is unapproved */
const UnapprovedUserHomepage = ({
    awaitingSetUp,
}: UnapprovedUserHomepageProps): ReactElement => {
    const theme = useTheme()
    const { firstName } = useGetUserData()
    return (
        <Stack
            flexDirection={{ xs: "column", md: "row" }}
            width="100%"
            height="100%"
            justifyContent="space-between"
        >
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                maxWidth={{ xs: "100%", md: "45%" }}
                paddingLeft="2%"
            >
                {" "}
                <Typography
                    variant="h4"
                    component="div"
                    fontWeight={500}
                    justifyContent="center"
                    alignContent="center"
                    color={theme.palette.primary.main}
                >
                    Welcome to ENA Connect Direct{" "}
                    <Box color={theme.palette.secondary.main} display="inline">
                        {firstName}
                    </Box>{" "}
                </Typography>
                <Typography
                    variant="h5"
                    color={theme.palette.primary.main}
                    fontWeight="light"
                >
                    {awaitingSetUp
                        ? "Your account needs a little bit more input from us before you can get going!"
                        : "Your account needs to be approved"}
                </Typography>
                <Typography
                    variant="body1"
                    fontWeight="light"
                    color={theme.palette.text.primary}
                >
                    {awaitingSetUp
                        ? "If you haven't already, please raise a support ticket requesting that we register you / your company. Once raised, we will work to get this resolved as quickly as possible. You can check the status of your ticket on the support portal at anytime. When we are finished, we'll let you know via email!"
                        : "Your company's admin needs to approve your account before you can get going. Please reach out to them and ask them to approve your account. Once approved, you will need to log out and back in again!"}
                </Typography>
                <DisplayIf condition={awaitingSetUp}>
                    <Box>
                        <AppButton
                            sx={{ marginY: 2, minWidth: "200px" }}
                            variant="outlined"
                            onClick={() =>
                                window.open(CONFIG.SN_PORTAL_URL, "_blank")
                            }
                        >
                            Go to Support Portal
                        </AppButton>
                    </Box>
                </DisplayIf>
            </Box>
            <Hidden mdDown>
                <LctHoneyCombMask maxWidth="50%" />
            </Hidden>
            <Hidden mdUp>
                <LctHoneyCombMask maxWidth="100%" />
            </Hidden>
        </Stack>
    )
}

export default UnapprovedUserHomepage
